import { render, staticRenderFns } from "./previewModal.vue?vue&type=template&id=01a4870c&scoped=true&"
import script from "./previewModal.vue?vue&type=script&lang=js&"
export * from "./previewModal.vue?vue&type=script&lang=js&"
import style0 from "./previewModal.vue?vue&type=style&index=0&id=01a4870c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a4870c",
  null
  
)

export default component.exports